import { AdtQuantityActions, AdtQuantityActionTypes } from '../../actions/quantity.actions';

/**
 * Quantity state
 */
export interface AdtQuantityState {
    selectedQuantities: { [formId: string]: number };
    minimumOrderQuantityBulk: number;
}

/**
 * Initial state of quantity
 */
export const initialState: AdtQuantityState = {
    selectedQuantities: undefined,
    minimumOrderQuantityBulk: undefined,
};

/**
 * Quantity reducer
 * @param {AdtQuantityState} state Quantity state
 * @param {AdtQuantityActions} action Quantity actions
 * @returns {AdtQuantityState}
 */
export function adtQuantityReducer(state = initialState, action: AdtQuantityActions): AdtQuantityState {
    switch (action.type) {
        case AdtQuantityActionTypes.LOAD_QUANTITY_SELECTED:
            const formIdChanging = String(Object.keys(action.payload));
            const newSelectedQuantities = state.selectedQuantities ?
                {
                    ...state.selectedQuantities,
                    ...action.payload,
                } :
                { ...action.payload };
            return {
                ...state,
                selectedQuantities: newSelectedQuantities,
                formIdChanging,
            } as AdtQuantityState;
        case AdtQuantityActionTypes.LOAD_INITIAL_QUANTITY:
            return {
                ...state,
                minimumOrderQuantityBulk: action.payload,
            } as AdtQuantityState;
        case AdtQuantityActionTypes.RESET:
            return initialState;
        default:
            return state;
    }
}
